/*eslint-disable*/
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

// @material-ui/core components
import { Badge, Box, Drawer, List, ListItem, ListItemText, Icon, useTheme } from "@mui/material";

import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";

// core components
import RoleGate from "../../auth/RoleGate";
import resources from "../../core/Localization/Localization.js";

import styles from "../../assets/jss/material-dashboard-react/components/sidebarStyle.js";
import useNotificationMessages from "../../hooks/useNotificationMessages";
import { getSxStyle } from "../../utils/getSxStyle.js";
import { areNotificationsEnabled } from "../../utils/areNotificationsEnabled.js";


export default function SidebarAdmin(props) {
    const theme = useTheme();
    const classes = styles(theme);

    // verifies if routeName is the one active (in browser input)
    function activeRoute(routeName) {
        return window.location.href.indexOf(routeName) > -1;
    }


    const { logo, image, logoText } = props;
    const [routes, setRoutes] = useState([...props.routes]);
    const notifications = useNotificationMessages();


    useEffect(() => {
        if (areNotificationsEnabled()) {
            const listeners = [];

            for (let i = 0; i < routes.length; i++) {
                if (!routes[i].badgeTopics || !routes[i].badgeTopics.length) {
                    continue;
                }

                for (let j = 0; j < routes[i].badgeTopics.length; j++) {
                    listeners.push(
                        notifications.subscribe(routes[i].badgeTopics[j], () => {
                            const newRoutes = [...routes];
                            if (!newRoutes[i].badge) {
                                newRoutes[i].badge = 0;
                            }
                            newRoutes[i].badge++;
                            setRoutes(newRoutes);
                        })
                    );
                }

                if (!!routes[i].badgeClearTopic) {
                    listeners.push(
                        notifications.subscribe(routes[i].badgeClearTopic, () => {
                            const newRoutes = [...routes];
                            newRoutes[i].badge = 0;
                            setRoutes(newRoutes);
                        })
                    );
                }
            }

            return () => {
                for (let i = 0; i < listeners.length; i++) {
                    listeners[i].unsubscribe();
                }
            };
        };
    }, []);


    const getListItemStyle = (baseStyle, isActive) => {
        return isActive
            ? { ...baseStyle, backgroundColor: 'rgb(203, 225, 0)' }
            : baseStyle;
    };

    const getListItemTextStyle = (baseStyle, isActive) => {
        return isActive
            ? { ...baseStyle, color: "#000000" }
            : baseStyle
    };

    const getListItemIconStyle = (baseStyle, isActive) => {
        return isActive
            ? { ...baseStyle, color: "#000000" }
            : baseStyle
    };


    var links = (
        <List sx={(theme) => getSxStyle(theme, styles, ['list'])}>
            {routes.map((prop, key) => {

                const isActive = activeRoute(prop.layout + prop.path);

                return (
                    <RoleGate roles={prop.roles} key={prop.name}>
                        <NavLink
                            to={prop.layout + prop.path}
                            style={{
                                position: "relative",
                                display: "block",
                                textDecoration: "none",
                                "&:hover,&:focus,&:visited,&": {
                                    color: "#ffffff",
                                },
                            }}
                            activeclassname="active"
                            key={key}
                        >

                            <ListItem button sx={(theme) => getListItemStyle(getSxStyle(theme, styles, ['itemLink', 'listItemClasses']), isActive)}>

                                {
                                    typeof prop.icon === "string"
                                        ? (<Icon sx={(theme) => getListItemIconStyle(getSxStyle(theme, styles, ['itemIcon']), isActive)} >{prop.icon}</Icon>)
                                        : (<prop.icon sx={(theme) => getListItemIconStyle(getSxStyle(theme, styles, ['itemIcon']), isActive)} />)
                                }

                                < Badge color="primary">
                                    <ListItemText
                                        primary={resources.sideBar[prop.name]}
                                        sx={(theme) => getListItemTextStyle(getSxStyle(theme, styles, ['itemText']), isActive)}
                                        disableTypography={true}
                                    />
                                </Badge>
                            </ListItem>
                        </NavLink>
                    </RoleGate>
                );
            })}

            {
                props.open
                    ? (
                        <Box sx={(theme) => getSxStyle(theme, styles, ['item'])} onClick={props.handleDrawerToggle}>
                            <ListItem button sx={(theme) => getSxStyle(theme, styles, ['itemLink'])}>
                                <MenuOpenIcon sx={(theme) => getSxStyle(theme, styles, ['itemIcon'])} />

                                <Badge color="primary">
                                    <ListItemText
                                        primary={resources.sideBar.close}
                                        sx={(theme) => getSxStyle(theme, styles, ['itemText'])}
                                        disableTypography={true}
                                    />
                                </Badge>
                            </ListItem>
                        </Box>
                    )
                    : (
                        <Box sx={(theme) => getSxStyle(theme, styles, ['item'])} onClick={props.handleDrawerToggle}>
                            <ListItem button sx={(theme) => getSxStyle(theme, styles, ['itemLink'])}>

                                <MenuIcon sx={(theme) => getSxStyle(theme, styles, ['itemIcon'])} />

                                <Badge color="primary">
                                    <ListItemText
                                        primary={resources.sideBar.open}
                                        sx={(theme) => getSxStyle(theme, styles, ['itemText'])}
                                        disableTypography={true}
                                    />
                                </Badge>
                            </ListItem>
                        </Box>
                    )
            }
        </List >
    );
    var brand = (
        <Box sx={(theme) => getSxStyle(theme, styles, ['logo'])}>
            <a
                href="http://localhost"
                style={classes.logoLink}
                target="_blank"
            >
                <Box sx={(theme) => getSxStyle(theme, styles, ['logoImage'])}>
                    <img src={logo} alt="logo" style={classes.img} />
                </Box>
                {logoText}
            </a>
        </Box>
    );
    return (
        <div key="left">
            <Drawer
                variant="persistent"
                anchor="left"
                open={props.open}
                transitionDuration={300}
                //onClose={props.handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                {brand}

                <Box sx={(theme) => getSxStyle(theme, styles, ['sidebarWrapper'])}>
                    {links}
                </Box>

                <Box sx={(theme) => getSxStyle(theme, styles, ['version'])}>
                    <p>v1.0.6</p>
                </Box>

                {
                    image !== undefined
                        ? <Box sx={(theme) => getSxStyle(theme, styles, ['background'])} style={{ backgroundImage: "url(" + image + ")" }} />
                        : null
                }
            </Drawer>
        </div>
    );
}

SidebarAdmin.propTypes = {
    handleDrawerToggle: PropTypes.func,
    bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
    logo: PropTypes.string,
    image: PropTypes.string,
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    open: PropTypes.bool,
};
